import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { updateProfileType } from "../../../../../service";
import { Button } from "../../../../form";
import EstablishmentsListEditor from "./establishmentsListEditor";

const ProfileCustomDataEditor = ({ org, profile, onSubmit = () => {} }) => {
  const [customData, setCustomData] = useState({
    establishmentsListForProfileForm: []
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (profile?.customData) {
      setCustomData({
        establishmentsListForProfileForm: profile.customData.establishmentsListForProfileForm || []
      });
    }
  }, [profile]);

  const handleEstablishmentsChange = (establishments) => {
    setCustomData((prev) => ({
      ...prev,
      establishmentsListForProfileForm: establishments
    }));
  };

  const handleSubmit = async () => {
    if (!profile?._id) {
      toast.error("Profile ID is required.");
      return;
    }

    try {
      setIsSubmitting(true);
      await updateProfileType(org._id, {
        _id: profile._id,
        type: "customData",
        customData
      });
      toast.success("Custom data saved successfully.");
      onSubmit();
    } catch (error) {
      toast.error("Failed to save custom data.");
      console.error("Failed to save custom data:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="space-y-6">
      <EstablishmentsListEditor
        establishments={customData.establishmentsListForProfileForm}
        onChange={handleEstablishmentsChange}
      />

      <div className="flex justify-end border-t pt-4">
        <Button.AdminPanelButton
          type="button"
          isSave={true}
          loading={isSubmitting}
          bgColor="#515151"
          textColor="#FFFFFF"
          color="white"
          onClick={handleSubmit}>
          Save
        </Button.AdminPanelButton>
      </div>
    </div>
  );
};

export default ProfileCustomDataEditor;
